import React, { useState, useRef, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import useBreadcrumbs from "../hooks/useBreadCrumbs";
import { useDispatch } from "react-redux";
import {
  setCaseId,
  setCaseInfoId,
  setCaseStage,
  setClaimNumber,
  setCaseTypeName,
  setIsSearchEditable,
  setStatus,
  setClientId,
  setIsDashboard,
  setNewCaseInFoID,
  setClient_StakeholderId,
  setIsUploadFile,
  setInjuryAvailable,
  setRecordAvailable,
  setQMEScheduleAvailable,
  setBillingAvailable,
  setIsViewSchedule,
} from "../redux/slice/CaseHeaderSlice";
import { setCaseSubjectId } from "../redux/slice/CaseSubjectSlice";
import { clearSearchQuery } from "../redux/slice/searchSlice";
import { setCurrentStage } from "../redux/slice/caseStagesSlice";
import { setactionType, setInterVal } from "../redux/slice/DashBoardSlice";

interface Child {
  name: string;
  slug?: string;
  icon?: string;
  children?: { name: string; slug?: string }[];
}

interface MenuItem {
  slug?: string | undefined;
  name: string;
  icon?: string;
  children?: Child[];
}

interface MenuProps {
  items: MenuItem[];
}

const Menu: React.FC<MenuProps> = ({ items }) => {
  const breadcrumbs = useBreadcrumbs();
  const newName = breadcrumbs[0]?.name?.split(" /")[0] || "";
  const dispatch = useDispatch();
  const [openMenuIndex, setOpenMenuIndex] = useState<number | null>(null);
  const [selectedMenuIndex, setSelectedMenuIndex] = useState<number | null>(
    null,
  );
  const [openChildIndex, setOpenChildIndex] = useState<{
    [key: number]: number | null;
  }>({});
  const location = useLocation();
  const navigate = useNavigate();
  const menuRef = useRef<HTMLDivElement>(null);
  const hiddenMenuRoutes = [
    "/search-case/view_qme_schedule",
    "/mytodos-view-invoice",
  ];
  const shouldHideMenu = hiddenMenuRoutes.includes(location.pathname);
  const [selectedChildIndex, setSelectedChildIndex] = useState<{
    [key: number]: number | null;
  }>({});

  useEffect(() => {
    const selectedMenuIndex = items.findIndex(
      (item) => item.name.trim().toLowerCase() === newName.trim().toLowerCase(),
    );
    setSelectedMenuIndex(selectedMenuIndex !== -1 ? selectedMenuIndex : 0);
  }, [items, newName]);
  useEffect(() => {
    if (!sessionStorage.getItem("reloaded")) {
      sessionStorage.setItem("reloaded", "true");
      window.location.reload();
    }
  }, []);

  const handleMenuClick = (
    index: number,
    slug?: string,
    hasChildren?: boolean,
  ) => {
    if (hasChildren) {
      if (openMenuIndex === index) {
        setOpenMenuIndex(null);
        setOpenChildIndex({});
      } else {
        setOpenMenuIndex(index);
        setOpenChildIndex({});
      }
    } else if (slug) {
      setSelectedMenuIndex(index);
      handleNavigation(slug);
    }
  };

  const handleChildClick = (
    menuIndex: number,
    childIndex: number,
    slug?: string,
  ) => {
    setOpenChildIndex({ [menuIndex]: childIndex });
    setSelectedChildIndex({ [menuIndex]: childIndex });
    if (slug) {
      handleNavigation(slug);
    }
  };

  const handleNavigation = (slug?: string) => {
    if (slug) {
      if (location.pathname === slug) {
        navigate(slug);
        window.location.reload();
      } else {
        navigate(slug);
        setOpenMenuIndex(null);
        setOpenChildIndex({});
        dispatch(setCaseInfoId(null));
        dispatch(setCaseId(null));
        dispatch(setCaseStage(null));
        dispatch(setClaimNumber(""));
        dispatch(setCaseTypeName(""));
        dispatch(setStatus(false));
        dispatch(setCaseSubjectId(""));
        dispatch(setIsSearchEditable(false));
        dispatch(setClientId(""));
        dispatch(clearSearchQuery());
        dispatch(setCurrentStage(""));
        dispatch(setIsDashboard(false));
        dispatch(setNewCaseInFoID(""));
        dispatch(setInterVal(""));
        dispatch(setactionType(""));
        dispatch(setClient_StakeholderId(null));
        dispatch(setIsUploadFile(false));
        dispatch(setInjuryAvailable(false));
        dispatch(setRecordAvailable(false));
        dispatch(setQMEScheduleAvailable(false));
        dispatch(setBillingAvailable(false));
        dispatch(setIsViewSchedule(false));
      }
    }
  };

  const handleClickOutside = (event: MouseEvent) => {
    if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
      setOpenMenuIndex(null);
      setOpenChildIndex({});
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  if (shouldHideMenu) {
    return null;
  }
  return (
    <nav
      className="navbar navbar-expand-lg"
      style={{
        backgroundColor: "#0092D5",
        padding: "0px",
        fontFamily: "Poppins",
        zIndex: "98",
        position: "sticky",
        top: "0px",
      }}
      ref={menuRef}
    >
      <Container fluid>
        <Row>
          <Col>
            <div style={{ margin: "0px 0px 0px 35px" }}>
              <div className="navbar-nav fade-in ">
                {items.map((item, index) => (
                  <div
                    key={index}
                    className={`nav-item dropdown ${
                      openMenuIndex === index ? "show" : ""
                    }`}
                    style={{ borderLeft: "1px solid #ccc" }}
                  >
                    <div
                      className={`nav-link ${
                        selectedMenuIndex === index
                          ? "bg-danger text-white"
                          : "text-white"
                      }`}
                      style={{
                        cursor: "pointer !important",
                        display: "flex",
                        alignItems: "center",
                        paddingLeft: "15px",
                        paddingRight: "15px",
                      }}
                      onClick={() =>
                        handleMenuClick(
                          index,
                          item?.slug,
                          !!item.children?.length,
                        )
                      }
                    >
                      {item.icon && (
                        <span
                          className="material-symbols-outlined"
                          style={{ marginRight: "10px", fontSize: "20px" }}
                        >
                          {item.icon}
                        </span>
                      )}
                      {item.name}
                    </div>

                    {openMenuIndex === index && item.children && (
                      <div
                        className={`dropdown-menu ${
                          openMenuIndex === index ? "show" : ""
                        }`}
                        style={{
                          position: "absolute",
                          top: "100%",
                          left: 0,
                          backgroundColor: "#fff",
                          borderRadius: "4px",
                          boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
                          display: `${
                            item.children?.[0]?.children ? "flex" : "block"
                          }`,
                          minWidth: "180px",
                          border: "1px solid #50c8ff",
                          borderTop: "0px",
                          padding: "4px",
                          width: "100%",
                        }}
                      >
                        {item.children.map((child, childIndex) => (
                          <li
                            key={childIndex}
                            className={
                              selectedChildIndex[index] === childIndex
                                ? "active-child"
                                : ""
                            }
                            style={{
                              fontWeight:
                                selectedChildIndex[index] === childIndex
                                  ? "bold"
                                  : "normal",
                            }}
                          >
                            <span
                              className="dropdown-item"
                              style={{ cursor: "pointer" }}
                              onClick={() => {
                                handleChildClick(index, childIndex, child.slug);
                                if (
                                  !child.children ||
                                  child.children?.length === 0
                                ) {
                                  handleNavigation(child.slug);
                                }
                              }}
                            >
                              {item.children?.[0]?.children ? (
                                <div>
                                  {child.icon && (
                                    <span
                                      className="material-icons"
                                      style={{
                                        marginRight: "10px",
                                        fontSize: "20px",
                                      }}
                                    >
                                      {child.icon}
                                    </span>
                                  )}
                                  <strong>{child.name}</strong>
                                </div>
                              ) : (
                                <>{child.name}</>
                              )}
                            </span>

                            {openChildIndex[index] === childIndex &&
                              child.children?.map((subChild, subChildIndex) => (
                                <React.Fragment key={subChildIndex}>
                                  <div
                                    className="dropdown-item"
                                    style={{
                                      paddingLeft: "48px",

                                      cursor: "pointer",
                                    }}
                                    onClick={() =>
                                      handleNavigation(subChild.slug)
                                    }
                                  >
                                    {subChild.name}
                                  </div>

                                  {subChildIndex <
                                    (child.children?.length ?? 0) - 1 && (
                                    <hr
                                      style={{
                                        margin: "4px 0",
                                        borderColor: "#000",
                                        marginLeft: "46px",
                                      }}
                                    />
                                  )}
                                </React.Fragment>
                              ))}
                          </li>
                        ))}
                      </div>
                    )}
                  </div>
                ))}
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </nav>
  );
};

export default Menu;
